const stringsComuns = {
    abrirDadosCompletosPaciente: 'Abrir dados completos',
    acessar: 'Acessar',
    agora: 'AGORA',
    achados: 'Achados',
    acoes: 'Ações',
    adicionar: 'Adicionar',
    adicionarRede: 'Adicionar rede',
    administrativo: 'Administrativo',
    aguarde: 'Aguarde...',
    aguardeSalaVideo: 'Aguarde enquanto configuramos a sala de atendimento...',
    ajudaCustoComPernoite: 'Número de ajuda de custo com pernoite',
    ajudaCustoSemPernoite: 'Número de ajuda de custo sem pernoite',
    alertaTodosVinculosAdicionados: (perfil) => `O perfil "${perfil}" já foi adicionado para todas as instituições deste usuário.`,
    alteracao: 'Alteração',
    alterar: 'Alterar',
    alterarMensagem: 'Alterar mensagem',
    arquivo: 'Arquivo',
    exameSemImagens: 'Este exame ainda não possui imagens',
    alterarMeusDados: 'Alterar meus dados',
    em: 'em',
    remover: 'Remover',
    altura: 'Altura (cm)',
    alturaMenorIgualTrezentos: 'Deve ser menor ou igual a 300',
    ambiente: 'Ambiente',
    ambienteDestino: 'Ambiente de destino',
    ambos: 'Ambos',
    anexo: 'Anexo',
    anexos: 'Anexos',
    anoCompetencia: 'Ano competência',
    anoConterQuatroCaracteres: 'O ano deve conter exatamente 4 caractéres',
    anoMesCompetencia: 'Ano/mês competência',
    anos: 'Anos',
    anosFuma: 'Anos que fuma',
    anosFumou: 'Anos que fumou',
    anosParouFumo: 'Anos que parou de fumar',
    antecedentes: 'Antecedentes',
    anterior: 'Anterior',
    apenasInteirosPositivos: 'Apenas números inteiros positivos são aceitos',
    aprovar: 'Aprovar',
    arquivo: 'Arquivo',
    assinar: 'Assinar',
    assunto: 'Assunto',
    atencao: 'Atenção',
    atipico: 'Atípico',
    ativa: 'Ativa',
    atividade: 'Atividade',
    ativo: 'Ativo',
    atualizandoPaciente: 'Atualizando dados do paciente',
    autenticacaoObrigatoria: 'Esta autenticação é obrigatória e não pode ser desvinculada.',
    autenticacaoSegura: 'Autenticação segura',
    autorizar: 'Autorizar',
    avaliar: 'Avaliar',
    avancar: 'Avançar',
    agendado: 'Agendado',
    agendada: 'Agendada',
    aumentarZoom: 'Aumentar Zoom',
    avisoImcCrianca1:
        'Para classificação do estado nutricional de pacientes abaixo de 19 anos, consulte os protocolos de classificação do estado nutricional do SISVAN, disponíveis no site do Ministério da Saúde.',
    avisoImcCrianca2: 'para acessar os protocolos.',
    avisoImcCrianca3: 'Equipe Núcleo Telessaúde UFSC.',
    avisoMensagemBloqueia: 'Essa mensagem bloqueia o uso do sistema para o seu usuário. Por favor, entre em contato com a administração do sistema para mais informações.',
    azureCpfIncompativelCadastro: 'O CPF vinculado a sua conta @ebserh.gov.br deve ser o mesmo de sua conta do STT.',
    bairro: 'Bairro',
    baixarPdf: 'Baixar PDF',
    bemVindo: 'Bem-vindo',
    buscar: 'Buscar',
    buscarFuncionario: 'Buscar funcionário',
    buscarInstituicao: 'Buscar instituição',
    buscarInstituicao: 'Buscar instituição',
    buscarPaciente: 'Buscar paciente',
    buscarProcedimentoSigtap: 'Buscar procedimentos SIGTAP',
    buscarSolicitante: 'Buscar solicitante',
    pesquisarSolicitante: 'Pesquisar solicitante',
    cadastrar: 'Cadastrar',
    cadastrarNovo: 'Cadastrar novo',
    cadastrarPaciente: 'Cadastrar paciente',
    cadsusInacessivel: 'O CADSUS está inacessível no momento. Tente novamente mais tarde.',
    campoInvalido: 'Inválido',
    campoObrigatorio: 'Campo obrigatório',
    cancelar: 'Cancelar',
    capitulo: 'Capítulo',
    carimboTempo: 'Carimbo do tempo',
    carregar: 'Carregar',
    carregando: 'Carregando',
    carregandoAnexo: 'Carregando anexo...',
    carregandoGaleria: 'Carregando galeria de imagens',
    carregandoImagens: 'Carregando imagens',
    carregandoProcessos: 'Carregando Processos...',
    cartaoSus: 'Cartão SUS',
    categoria: 'Categoria',
    cbo: 'CBO',
    cboFamilia: 'CBO família',
    cboOcupacao: 'CBO ocupação',
    cep: 'CEP',
    ciap2: 'CIAP-2',
    ciap2Adicionado: 'CIAP-2 adicionado',
    ciap2AdicionadoAnteriormente: 'Este CIAP-2 já foi adicionado anteriormente',
    cid10: 'CID-10',
    cid10Adicionado: 'CID-10 adicionado',
    cid10AdicionadoAnteriormente: 'Este CID-10 já foi adicionado anteriormente',
    cid10Principal: 'CID-10 Principal',
    cid10Secundario: 'CID-10 Secundário',
    cidade: 'Município',
    cidadeDestino: 'Município de destino',
    cidadeOrigem: 'Município de origem',
    cidadeProcedencia: 'Município de procedência',
    cidadeUf: 'Município/UF',
    cigarrosDia: 'Cigarros por dia',
    cinquentaMb: '50 Mb',
    classificacao: 'Classificação',
    classificacaoNutricional: 'Classificação do estado nutricional',
    cliqueAqui: 'CLIQUE AQUI',
    cm: 'cm(s)',
    cnes: 'CNES',
    cnesMaximo10Digitos: 'O CNES deve conter no máximo 10 dígitos',
    cnesApenasNumeros: 'O CNES deve conter apenas números',
    cnesLimiteMaximo: 'O CNES não é válido',
    cnpjInvalido: 'CNPJ inválido',
    cns: 'CNS',
    cnsInvalido: 'CNS inválido',
    cnsPaciente: 'CNS do paciente',
    sgpe: 'SGPE',
    codigo: 'Código',
    comLaudo: 'Laudado',
    comorbidades: 'Comorbidades',
    complemento: 'Complemento',
    comprovanteComparecimento: 'Comprovante de comparecimento',
    comprovantesComparecimento: 'Comprovantes de comparecimento',
    conclusao: 'Conclusão',
    concordar: 'Concordar',
    concordo: 'Concordo',
    confirmacao: 'Confirmação',
    confirmacaoLeitura: 'Confirmação de leitura',
    confirmar: 'Confirmar',
    confirmarDesinvalidar: 'Você deseja realmente desinvalidar este exame?',
    confirmarDesvincularAutenticacaoExterna: (origem) => {
        switch (origem) {
            case 'AZURE_AD':
                return 'Você tem certeza que deseja desvincular sua conta Microsoft? A mesma poderá ser vinculada novamente.';

            case 'GOV_BR':
                return 'Você tem certeza que deseja desvincular sua conta gov.br? A mesma poderá ser vinculada novamente.';

            default:
                return 'Você tem certeza que deseja desvincular esta conta? A mesma poderá ser vinculada novamente.';
        }
    },
    confirmarEnviarCorrecaoPaciente: 'Você confirma a atualização dos dados do paciente?',
    confirmarExclusao: 'Você confirma a exclusão desta equipe de saúde?',
    confirmarExclusaoMensagemAnexoAtendimento: 'Você confirma a exclusão deste anexo?',
    confirmarExclusaoMensagemAtendimento: 'Você confirma a exclusão desta mensagem?',
    confirmarInvalidarExame: 'Você deseja realmente invalidar este exame?',
    confirmarLeitura: 'Confirmar leitura',
    confirmarPriorizarExame: 'Você deseja realmente priorizar este exame?',
    confirmarTrocarRedeExame: 'Você deseja realmente trocar a rede deste(s) exame(s)?',
    confirmarVincularAutenticacaoExterna: (origem, email) => {
        switch (origem) {
            case 'AZURE_AD':
                return email ? `Você tem certeza que deseja vincular a conta de e-mail ${email} ao seu login?` : 'Você tem certeza que deseja vincular esta conta Microsoft ao seu login?';

            case 'GOV_BR':
                return 'Você tem certeza que deseja vincular esta conta gov.br ao seu login?';

            default:
                return 'Você tem certeza que deseja vincular esta conta ao seu login?';
        }
    },
    conselhoTrabalho: 'Conselho de trabalho',
    caracteresEspeciais: 'Caracteres especiais não são permitidos',
    contato: 'Contato',
    continuar: 'Continuar',
    copiaExames: 'Cópia de Exames',
    copiar: 'Copiar',
    copiarLaudo: 'Copiar Laudo?',
    corrigirErrosFormulario: 'Por favor, corrija os pontos de atenção do formulário antes de continuar.',
    cpf: 'CPF',
    cpfCnsObrigatorio: 'CPF ou CNS é obrigatório para pesquisa',
    cpfInvalido: 'CPF inválido',
    cpfPaciente: 'CPF do paciente',
    crm: 'CRM',
    crmAutorizador: 'CRM do autorizador',
    crmRms: 'CRM/RMS',
    dadosAgendamento: 'Dados do agendamento',
    dadosCompletosPaciente: 'Dados completos do Paciente',
    dadosContato: 'Dados de contato',
    dadosDaSolicitacao: 'Dados da solicitação',
    dadosExame: 'Dados do exame',
    dadosGerais: 'Dados gerais',
    dadosPaciente: 'Dados do paciente',
    dadosPacienteIncompletos: 'Dados do paciente incompletos',
    dadosProfissionais: 'Dados profissionais',
    data: 'Data',
    dataAte: 'Até',
    dataAtendimento: 'Data de atendimento',
    dataCriacao: 'Data da criação',
    dataDe: 'De',
    dataExame: 'Data',
    dataFinal: 'Data final',
    dataFinalAnteriorDataInicial: 'Data final deve ser posterior a data inicial',
    dataFinalExame: 'Data final do exame',
    dataFinalInvalidacao: 'Data final da invalidação',
    dataFinalLaudo: 'Data final do laudo',
    dataFinalParecer: 'Data final do parecer',
    dataFinalSolicitacao: 'Data final da solicitação',
    dataHora: 'Data/hora',
    dataInicial: 'Data inicial',
    dataInicialExame: 'Data inicial do exame',
    dataInicialInvalidacao: 'Data inicial da invalidação',
    dataInicialLaudo: 'Data inicial do laudo',
    dataInicialParecer: 'Data inicial do parecer',
    dataInicialSolicitacao: 'Data inicial da solicitação',
    dataInvalida: 'Data inválida',
    dataMaxExame: 'A data não pode ser superior a 30 dias da data atual',
    dataNascimento: 'Data de nascimento',
    dataNascimentoMinima: 'A data de nascimento não pode ser anterior a 01/01/1900',
    dataPreenchimentoLaudoMedico: 'Data de preenchimento do laudo médico',
    dataProrrogada: 'Data prorrogada',
    dataSolicitacao: 'Data da solicitação',
    dataUltimaMovimentacao: 'Data da última movimentação',
    de: 'de',
    decs: 'DeCS',
    decsAdicionado: 'DeCS adicionado',
    decsAdicionadoAnteriormente: 'Este DeCS já foi adicionado anteriormente',
    desconhecido: 'Desconhecido',
    descricao: 'Descrição',
    descricaoDecs:
        'O DeCS é um vocabulário dinâmico totalizando 30.369 descritores, sendo destes 25.671 do MeSH e 4698 exclusivamente do DeCS. Existem 2001 códigos hierárquicos de categorias DeCS a 1458 descritores MeSH.',
    descricaoEstudo: 'Descrição do estudo',
    descritor: 'Descritor',
    descritorAntecessor: 'Descritor antecessor',
    descritores: 'Descritores',
    descritoresSBC: 'Descritores SBC',
    desde: 'Desde',
    desligada: 'Desligada',
    destino: 'Destino',
    desvincular: (origem) => {
        switch (origem) {
            case 'AZURE_AD':
                return 'Desvincular sua conta Microsoft Azure';

            case 'GOV_BR':
                return 'Vincular sua conta gov.br';

            default:
                return 'Desvincular';
        }
    },
    detalhes: 'Detalhes',
    detalhesSolicitacao: 'Detalhes da solicitação',
    devolver: 'Devolver',
    dezMb: '10 Mb',
    digitador: 'Digitador',
    diminuirZoom: 'Diminuir Zoom',
    direcionar: 'Direcionar',
    direcionarExameLaudo: 'Direcionar exame para laudo',
    discordar: 'Discordar',
    discordo: 'Discordo',
    download: 'Download',
    duracao: 'Duração',
    editada: 'Editada',
    editar: 'Editar',
    editarPerfil: 'Editar perfil',
    email: 'E-mail',
    emailDuplicado: 'O email inserido já existe. Por favor, informe outro e-mail para continuar.',
    emailInvalido: 'E-mail inválido',
    emailObrigatorio: 'E-mail obrigatório',
    encaminhar: 'Encaminhar',
    encaminharRegulador: 'Encaminhar ao regulador',
    entrar: 'Entrar',
    enviar: 'Enviar',
    enviarExame: 'Enviar exame',
    enviarImagens: 'Enviar imagens',
    envioImagens: 'Envio de imagens',
    equipamento: 'Equipamento',
    equipeDuplicada: 'Essa equipe já foi adicionada',
    equipeSaude: 'Equipe de Saúde',
    equipeSaudeFamilia: 'Equipe de Saúde da Família',
    erro: 'Erro',
    erroAutenticacaoExternaJaAberta: 'A janela de autenticação externa já está aberta em outra aba do seu navegador.',
    erroBaixarPlanilha: 'Não foi possível baixar a planilha para cálculo da classificação do estado nutricional do paciente.',
    erroCarregamentoGaleria: 'Ocorreu um erro no carregamento da galeria. Por favor, contacte o administrador.',
    erroConectarBBB: 'Erro ao conectar na sala de áudio e vídeo. Deseja tentar novamente?',
    erroConteudoHtml: 'O campo deve ter pelo menos 10 caracteres válidos',
    erroCopia: 'Erro ao copiar exame.',
    erroDataFutura: 'Data não pode ser futura',
    erroDataFuturo: 'Data deve ser anterior a data final',
    erroDataMaiorDataFinal: 'Data deve ser anterior a data final',
    erroDataMenorDataInicial: 'Data deve ser posterior a data inicial',
    erroDataMenorDataInicio: 'Data deve ser posterior a data "De"',
    erroDataObrigatoria: 'A data é obrigatória.',
    erroDataPassada: 'A data não pode ser passada.',
    erroDesinvalidar: 'Não foi possível desinvalidar o exame. Tente novamente. Se o erro persistir, entre em contato com o suporte.',
    erroDownloaEstudoDicom: 'Download do estudo dicom indisponível. Tente novamente mais tarde.',
    erroEnviarAnexo: 'Não foi possível enviar esse anexo. Tente novamente mais tarde.',
    erroFaltaPermissao: 'O seu usuário não tem permissão para acessar essa funcionalidade no momento.',
    erroFuncionarioDuplicado: 'Esse funcionário já foi adicionado anteriormente.',
    erroGenerico: 'Ocorreu um erro desconhecido. Entre em contato com os administradores do sistema.',
    erroGerarProtocoloEnvioExame: 'O exame foi registrado, mas não foi possível gerar o protocolo. Para ter acesso ao protocolo, acesse a tela de exames.',
    erroGerarTermo: 'Não foi possível gerar o termo de autorização. Tente imprimir o termo através da tela de exames.',
    erroIgnorarExame: 'Não foi possível ignorar o exame. Se o mesmo exame for carregado, tente ignorá-lo novamente. Se o erro persistir, entre em contato com o suporte.',
    erroImpressaoExame: 'Ocorreu um erro na impressão do exame. Tente novamente. Se o erro persistir, entre em contato com o suporte.',
    erroInvalidarExame: 'Não foi possível invalidar o exame. Tente novamente. Se o erro persistir, entre em contato com o suporte.',
    erroMaxCaracteres: (maxCaracteres, nomeCampo) => `O campo ${nomeCampo} deve ter no máximo ${maxCaracteres} caractéres.`,
    erroNomeArquivoNomePaciente:
        'O sistema identificou uma diferença entre o nome do paciente e o nome do arquivo anexado. Por favor, verifique se o arquivo contém o nome igual ao nome do traçado, incluindo sobrenomes.',
    erroNomeArquivoNoname:
        'O sistema identificou que o nome do paciente não foi incluído no exame. Por favor, refaça o exame e adicione o nome completo, conforme estabelecido no protocolo de realização exame.',
    erroPriorizarExame: 'Não foi possível priorizar o exame. Tente novamente. Se o erro persistir, entre em contato com o suporte.',
    erroSexoPlanilha: 'Os cálculos da classificação do estado nutricional só podem ser feitos em pacientes do sexo masculino ou feminino.',
    erroTamanhoArquivo: 'O arquivo não pode ter mais de % Mb',
    erroTamanhoArquivo2Mb: 'Arquivo não pode ter mais de 2 Mb',
    erroTamanhoArquivo10Mb: 'Arquivo não pode ter mais de 10 Mb',
    erroTamanhoArquivo50Mb: 'Arquivo não pode ter mais de 50 MB',
    erroTamanhoArquivo500Mb: 'Arquivo não pode ter mais de 500 Mb',
    erroTamanhoCombinadoArquivosMaiorQue50MB: 'O tamanho combinado dos arquivos anexos não pode ser maior que 50 MB',
    erroTrocarRedeExame: 'Não foi possível trocar a rede do exame. Tente novamente. Se o erro persistir, entre em contato com o suporte.',
    espacosNaoPermitidos: 'Espaços não são permitidos',
    especificacao: 'Especificação',
    especificacaoTempo: 'Especificação do tempo',
    estado: 'Estado',
    estadoConselhoTrabalho: 'Estado do conselho de trabalho',
    estaturaIdadeEscoreZ: 'Estatura por idade (segundo Escore-Z)',
    estaturaIdadePercentil: 'Estatura por idade (segundo Percentil)',
    etilismo: 'Etilismo',
    exame: 'Exame',
    exameDirecionado: 'Exame direcionado',
    exameDuplicado: 'Exame duplicado',
    exameEnviadoSucesso: 'Exame enviado com sucesso.',
    exameErroLaudo: 'Ocorreu um erro ao carregar o laudo. Tente novamente mais tarde.',
    exameInvalidado: 'Exame invalidado',
    exameMaisAntigoSemLaudo: 'Data do exame mais antigo sem laudo',
    examePriorizado: 'Exame priorizado',
    exameRegistrado: 'Exame(s) registrado(s) com sucesso',
    exames: 'Exames',
    examesComLaudo: 'Exames laudados',
    examesCopiados: 'Exames copiados com sucesso.',
    exameSelecionado: 'Exame selecionado',
    exameSemLaudo: 'Não há laudo disponível para esse exame.',
    examesInvalidos: 'Exames inválidos',
    examesSelecionados: 'Exames selecionados',
    examesValidos: 'Exames válidos',
    excluir: 'Excluir',
    exigeComplemento: 'Exige complemento?',
    fatorRh: 'Fator Rh',
    fechar: 'Fechar',
    fecharJanelaDestaque: 'Fechar janela de destaque',
    fecharOutrasGuias: 'Fechar outras guias',
    fecharTodasGuias: 'Fechar todas as guias',
    feminino: 'Feminino',
    configuracoes: 'Configurações',
    finalizar: 'Finalizar',
    finalizarPreenchimentoUltimoAnexo: 'Finalize o preenchimento do último anexo antes de adicionar um novo',
    formatoArquivoInvalido: 'Formato de arquivo inválido.',
    formatosArquivo: 'Arquivo (.pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx)',
    formatosInput: {
        hhmm: 'HH:MM',
        validacaoHhMm: 'Deve ser especificado hora(s) e minuto(s)'
    },
    frequencia: 'Frequência',
    funcionario: 'Funcionário',
    funcionarioAdicionado: 'Funcionário adicionado com sucesso.',
    funcionarioDigitador: 'Funcionário digitador',
    funcionarioExecutante: 'Funcionário executante',
    funcionarioPreenchedor: 'Funcionário preenchedor',
    funcionarioRegulador: 'Funcionário regulador',
    funcionarios: 'Funcionários',
    funcionarioSolicitante: 'Funcionário solicitante',
    galeriaAnexos: 'Galeria de anexos',
    galeriaImagens: {
        anexosDisponiveis: 'Os anexos estão disponíveis para download.',
        carregandoImagens: 'Carregando imagens. Por favor aguarde...',
        dicas: {
            comZoom: 'Com zoom aplicado, você pode usar o botão esquerdo do mouse para movimentar a imagem para uma região de interesse.',
            sairModoDestacado: 'Clique no botão abaixo para retornar ao modo original.',
            useScroll: 'Use o scroll do mouse para aplicar zoom.',
            useSetas: 'Use as setas laterais ou a ação de arrastar para navegar entre as imagens.',
            esconderLegenda: 'Dê um clique simples na imagem para esconder ou mostrar a legenda e título da imagem.',
        },
        erroCarregarImagem: 'Ocorreu um erro ao carregar esta imagem.',
        erroConversaoImagem: 'Um ou mais anexos não conseguiram ser convertidos para visualização.',
        galeriaDestacada: 'A galeria de imagens se encontra no modo destacado, em outra janela do seu navegador.'
    },
    genero: 'Gênero',
    gerandoDocumento: 'Gerando documento',
    gerandoNumeroProtocolo: 'Gerando protocolo',
    gerandoTCLE: 'Gerando Termo de Consentimento Livre e Esclarecido',
    gerarProtocolos: 'Gerar protocolos',
    gerarResumo: 'Gerar resumo',
    grupo: 'Grupo',
    grupoEtario: 'Grupo etário',
    grupoSanguineo: 'Grupo sanguíneo',
    headingSttEbserh: 'STT - EBSERH',
    historico: 'Histórico',
    historicoPaciente: 'Histórico do paciente',
    hora: 'Hora',
    horaInvalida: 'A combinação de horas e minutos informada é inválida',
    horas: 'hora(s)',
    iaStt: 'Olá, sou a IA do STT!',
    idade: 'Idade',
    idadeMaiorDezoito: 'O funcionário deve ter mais do que 18 anos',
    identificador: 'Identificador',
    ignorandoExame: 'Ignorando exame',
    ignorar: 'Ignorar',
    imagem: 'Imagem',
    imagens: 'Imagens',
    imagensIndisponiveis: 'Algumas imagens não estão disponíveis para visualização. Para visualizar as imagens, entre em contato com o suporte.',
    imc: 'IMC',
    imcEscoreZ: 'IMC por idade (segundo Escore-Z)',
    imcPercentil: 'IMC por idade (segundo Percentil)',
    impressaoDesabilitada: 'Impressão desabilitada nesta página.',
    impressaoImagens: {
        duasImagens: 'Duas imagens',
        mensagemImprimir: 'Imprimir',
        mensagemOpcaoImpressao: 'Quantas imagens por página deseja imprimir?',
        nenhumaImagem: 'Nenhuma Imagem',
        oitoImagens: 'Oito imagens',
        quatroImagens: 'Quatro imagens',
        seisImagens: 'Seis imagens',
        umaImagem: 'Uma imagem'
    },
    imprimir: 'Imprimir',
    imprimirProtocolo: 'Imprimir protocolo',
    imprimirTermo: 'Termo de autorização',
    inativa: 'Inativa',
    inativar: 'Inativar',
    inativo: 'Inativo',
    indicacaoClinica: 'Indicação clínica',
    infeccoes: 'Infecções',
    infoClassificacaoNutricional: 'Informações sobre a Classificação do Estado Nutricional',
    informacao: 'Informação',
    informacoesExame: 'Informações do exame',
    informeNomeCompleto: 'Informe o nome completo',
    inicio: 'Início',
    instituicao: 'Instituição',
    instituicaoDuplicada: 'Essa instituição já foi adicionada',
    instituicaoExecutante: 'Instituição executante',
    instituicaoObrigatoria: 'É obrigatório a adição de pelo menos uma instituição de vínculo.',
    instituicaoResponsavel: 'Instituição responsável',
    instituicaoSolicitante: 'Instituição solicitante',
    instituicoes: 'Instituições',
    intensidade: 'Intensidade',
    interestadual: 'Interestadual',
    internacao: 'Internação',
    intraestadual: 'Intraestadual',
    invalidandoExame: 'Invalidando exame',
    invalidar: 'Invalidar',
    invalido: 'Inválido',
    judicial: 'Judicial',
    justificativa: 'Justificativa',
    justificativaObrigatoria: 'A justificativa é obrigatória.',
    justificativaTransporteRecomendado: 'Justificativa do transporte recomendável',
    largura: 'Largura',
    laudo: 'Laudo',
    laudoAguardandoComplemento: 'Complemento',
    laudoAssinado: 'Laudo assinado',
    laudoEmissao: 'Emissão',
    laudosAssinados: 'laudos assinados',
    laudosEmitidos: 'Laudos emitidos',
    laudosGraves: 'Laudos graves',
    laudosImportantes: 'Laudos importantes',
    laudoTemporario: 'Temporário',
    liCiente: 'Li e estou ciente.',
    ligada: 'Ligada',
    limpar: 'Limpar',
    linhasPorPagina: 'Linhas por página',
    localizacao: 'Localização',
    localPreenchimentoLaudoMedico: 'Local de preenchimento do laudo médico',
    login: 'Login',
    loginDuplicado: 'O login inserido já existe. Por favor, informe outro para continuar.',
    loginProibidoEspaco: 'O login não pode conter espaços',
    logout: 'Logout',
    logradouro: 'Logradouro',
    maiorZero: 'Deve ser maior que 0',
    maisMedicos: 'Mais médicos',
    maisMedicosResidencia: 'Mais médicos / PROVAB / Residência',
    maisSimbolo: '+',
    masculino: 'Masculino',
    materiaisSuporte: 'Materiais de apoio',
    matutino: 'Matutino',
    maximo10Caracteres: 'Deve ter no máximo 10 caracteres',
    maximo10ExamesSelecionados: 'Por questões de desempenho, só será possível assinar lotes de até 10 exames por vez.',
    maximo30Caracteres: 'Deve ter no máximo 30 caracteres',
    maximo255Caracteres: 'Deve ter no máximo 255 caracteres',
    medicamento: 'Medicamento',
    medico: 'Médico',
    medicoExecutor: 'Médico executor',
    medicoSolicitante: 'Médico solicitante',
    melhor: 'Melhor',
    menosSimbolo: '-',
    mensagemAnexoExcluidoChat: 'Este anexo foi excluído.',
    mensagemBoasVindas: 'Mensagem de boas-vindas',
    mensagemCancelarEnvioImagens: 'Deseja cancelar o envio das imagens?',
    mensagemConfirmacaoEnvioSolicitacao: 'Você confirma o envio da solicitação?',
    mensagemConfirmarEnvioExame: 'Deseja enviar as fotos das lesões agora?',
    mensagemConfirmarTermo_solicitacao: 'Deseja imprimir o TCLE? O mesmo documento será impresso ao término do envio das imagens.',
    mensagemEnviandoImagens: 'Enviando imagens',
    mensagemErroBuscaCid10Termo:
        'Para pesquisas utilizando a opção "Termo completo" é obrigatório informar o termo a ser encontrado. Para pesquisas onde não se pretende informar o termo a ser encontrado deverá ser utilizada a opção "Termo parcial".',
    mensagemErroBuscaInstituicaoSemFiltros: 'Informe ao menos um filtro para realizar a pesquisa.',
    mensagemErroBuscaTermo: 'Para pesquisar é obrigatório informar o termo a ser encontrado.',
    mensagemErroGeral: 'Ocorreu um erro. Tente novamente mais tarde',
    mensagemExcluidaChat: 'Esta mensagem foi excluída.',
    mensagemImprimirImagensExame: 'Você gostaria de imprimir também as imagens deste exame?',
    mensagemPopupBloqueado:
        'Parece que o seu navegador bloqueou uma ou mais abas do sistema de serem abertas. Por favor, permita que seu navegador abra pop-ups (geralmente, na barra de endereços do navegador) e repita a operação.',
    mensagemAcaoSuspeita: `Não foi possível validar a integridade de sua ação. Por favor, tente realizar a solicitação de cadastro novamente, certificando-se de:
                            - Desativar temporariamente o uso de VPNs.
                            - Acessar a página em uma janela normal do navegador (evite o modo anônimo).
                            - Pausar extensões de bloqueio de anúncios nesta página.
                            - Estar conectado ao seu provedor de e-mail no navegador.`,
    meusDados: 'Meus dados',
    minimo1Caracter: 'Deve ter no mínimo 1 caracter',
    minTresLetras: 'A descrição deve ter ao menos 3 caracteres',
    minutos: 'minuto(s)',
    modalidade: 'Modalidade',
    modalidadeDuplicada: 'Essa modalidade já foi adicionada',
    modalidadeInstituicaoDuplicada: 'Essa combinação de modalidade e instituição já foi adicionada',
    modalidadeObrigatoria: 'É obrigatório a adição de pelo menos uma modalidade de vínculo.',
    modalidadeRedeDuplicada: 'Essa combinação de modalidade e rede já foi adicionada',
    modulo: 'Módulo',
    modulos: 'Módulos',
    motivo: 'Motivo',
    motivoEncaminhamento: 'Motivo do encaminhamento',
    movimentacao: 'Movimentação',
    movimentacoes: 'Movimentações',
    muitoPior: 'Muito pior',
    mumeroPositivo: 'Deve ser maior que 0',
    municipio: 'Município',
    municipios: 'Municípios',
    municipiosAdicinados: 'Municípios adicionados',
    nao: 'Não',
    naoAutorizado: 'Não autorizado',
    naoFoiPosisvelCarregarExamesInvalidos: 'Não foi possível carregar os dados de exames inválidos',
    naoFoiPossivelCarregarExamesComLaudo: 'Não foi possível carregar os dados de exames laudados',
    naoFoiPossivelCarregarLaudosEmitidos: 'Não foi possível carregar os dados de laudos emitidos',
    naoFoiPossivelCarregarSemLaudo: 'Não foi possível carregar os dados de exames sem laudo',
    naoFoiPossivelCarregarSemLaudo72h: 'Não foi possível carregar os dados de exames com laudo atrasado',
    naoFoiPossivelCarregarTotais: 'Não foi possível carregar os dados de produtividade',
    naoInformado: 'Não informado',
    naoRespondeu: 'Não respondeu',
    naoUsou: 'Não usou',
    negar: 'Negar',
    nenhum: 'Nenhum',
    nenhumaAlteracaoDetectada: 'Nenhuma alteração detectada nos dados do paciente.',
    nenhumCiap2Adicionado: 'Nenhum CIAP-2 adicionado',
    nenhumCid10Adicionado: 'Nenhum CID-10 adicionado',
    nenhumDecsAdicionado: 'Nenhum DeCS adicionado',
    nenhumPacienteEncontrado: 'Cadastro não encontrado com os dados informados.',
    nenhumPacienteEncontradoCadastro: 'Nenhum paciente encontrado. Deseja cadastrar?',
    nenhumPerfilAdicionado: 'Nenhum perfil adicionado',
    nenhumRegistroEncontrado: 'Nenhum registro encontrado',
    nenhumResultado: 'Nenhum resultado a ser exibido',
    nenhumSigtapAdicionado: 'Nenhum SIGTAP adicionado',
    nome: 'Nome',
    nomeAbreviado: 'Nome abreviado',
    nomeCompleto: 'Nome completo',
    nomeFuncionario: 'Nome do funcionário',
    nomeInvalido: 'Nome inválido',
    nomeMae: 'Nome da mãe',
    nomePaciente: 'Nome do paciente',
    nomePacienteInvalido: 'Informe o nome completo (somente letras)',
    nomePacienteSomenteLetras: 'O nome do paciente só pode conter letras',
    nomeProcedimento: 'Nome do Procedimento',
    nomeSistema: 'Sistema Integrado Catarinense de Telemedicina e Telessaúde',
    nomeSolicitanteSomenteLetras: 'O nome do solicitante só pode conter letras',
    notasAtualizacao: 'Notas de atualização',
    notificacoes: 'Notificações',
    novaRede: 'Nova rede',
    novo: 'Novo',
    novo: 'Novo',
    numero: 'Número',
    numeroAcompanhantes: 'Número de acompanhantes',
    numeroAcompanhantesNegativo: 'O número de acompanhantes não pode ser negativo.',
    numeroAcompanhantesObrigatorio: 'O número de acompanhantes é obrigatório.',
    numeroCelularInvalido: 'Número de celular deve ter 9 dígitos',
    numeroCelularNoveDigitos: 'Número de celular deve ter 9 dígitos',
    numeroConselhoTrabalho: 'Número do conselho de trabalho',
    numeroConselhoTrabalhoDuplicado: 'Este número de conselho de trabalho já existe',
    numeroExame: 'Número do exame',
    numeroLaudo: 'Número do laudo',
    numeroPedido: 'Número do pedido',
    numeroPedidoCaracteres: 'O número do pedido não pode exceder 20 caracteres.',
    numeroTelefoneInvalido: 'Número de telefone deve ter 8 dígitos',
    numeroTelefoneOitoDigitos: 'Número de telefone deve ter 8 dígitos',
    numeroVagas: 'Número de vagas',
    nunca: 'Nunca',
    nuncaFumou: 'Nunca fumou',
    obesidade1: 'Obesidade Grau 1',
    obesidade2: 'Obesidade Grau 2',
    obesidade3: 'Obesidade Grau 3',
    observacao: 'Observação',
    observacaoHcp: 'Relate aqui a história clínica pregressa que considere pertinente e que possa auxiliar no diagnóstico',
    observacaoTecnica: 'Observação técnica',
    observacoes: 'Observações',
    observacoesTecnico: 'Observações do técnico',
    ocupacao: 'Ocupação',
    ocupacaoNaoClassificada: 'Ocupação não classificada',
    ok: 'Ok',
    opcoes: 'Opções',
    operacaoSucesso: 'Operação realizada com sucesso.',
    ordenacao: 'Ordenação',
    origem: 'Origem',
    outras: 'Outras',
    outrasFormasVisualizarImagem: 'Outras formas de se visualizar imagens',
    outrasInformacoes: 'Outras informações',
    outro: 'Outro',
    outros: 'Outros',
    outrosContatosPaciente: 'Outros contatos do paciente',
    outrosExames: 'Outros Exames',
    paciente: 'Paciente',
    pacienteObrigatorio: 'O paciente é obrigatório',
    pacientes: 'Pacientes',
    paginaInicial: 'Página inicial',
    pais: 'País',
    palavraChave: 'Palavra-chave',
    participacao: 'Participação',
    participacoes: 'Participações',
    pendencias: 'Pendências',
    percentual: 'Percentual',
    perfil: 'Perfil',
    perfilCidadeDuplicado: 'Essa combinação de perfil e município já foi adicionada',
    perfilDuplicado: 'Esse perfil já foi adicionado',
    perfilEstadoDuplicado: 'Essa combinação de perfil e estado já foi adicionada',
    perfilInstituicaoDuplicado: 'Essa combinação de perfil e instituição já foi adicionada',
    perfilRedeDuplicado: 'Essa combinação de perfil e rede já foi adicionada',
    perfis: 'Perfis',
    perfisStt1: 'Perfis do STT-1',
    perfisStt2: 'Perfis do STT-2',
    periodo: 'Período: de ',
    personalizacao: 'Personalização',
    peso: 'Peso (kg)',
    pesoEstaturaEscoreZ: 'Peso por estatura (segundo Escore-Z)',
    pesoEstaturaPercentil: 'Peso por estatura (segundo Percentil)',
    pesoIdadeEscoreZ: 'Peso por idade (segundo Escore-Z)',
    pesoIdadePercentil: 'Peso por idade (segundo Percentil)',
    pesoMenorIgualDuzentos: 'Deve ser menor ou igual a 200',
    pesoMenorIgualTrezentosCinquenta: 'Deve ser menor ou igual a 350kg',
    pesoSaudavel: 'Peso Saudável',
    pesquisa: 'Pesquisa',
    pesquisaAvancada: 'Pesquisa avançada',
    pesquisaExames: 'Pesquisa de exames',
    pesquisaLaudosGraves: 'Pesquisa de laudos graves',
    pesquisandoDadosCadsus: 'Pesquisando dados do CADSUS',
    pesquisar: 'Pesquisar',
    pesquisaSolicitacoesExame: 'Pesquisa de solicitações de exame',
    pior: 'Pior',
    ponto: 'Ponto',
    pontoDeReferencia: 'Ponto de referência',
    pontoDestino: 'Ponto de destino',
    popupBloqueado: 'Pop-up bloqueado',
    preOperatorio: 'Pré-operatório',
    preparandoDocumento: 'Preparando documento(s)',
    priorizado: 'Priorizado',
    priorizandoExame: 'Priorizando exame',
    priorizar: 'Priorizar',
    procedimento: 'Procedimento',
    procedimentoSolicitacdo: 'Procedimento solicitado',
    procurar: 'Procurar',
    procurandoCertificadosUsuario: 'Procurando certificados do usuário',
    producao: 'Produção',
    profissao: 'Profissão',
    profissaoInvalida: 'Profissão inválida',
    profissionalSolicitante: 'Profissional solicitante',
    protocolo: 'Protocolo',
    protocoloCopiado: 'Protocolo copiado',
    provab: 'PROVAB',
    proximo: 'Próximo',
    prurido: 'Prurido',
    publicar: 'Publicar',
    quantidadeExames: 'Quantidade de exames',
    quantidadeMinima: 'A quantidade miníma é 1',
    quinhentosMb: '500 Mb',
    raca: 'Raça',
    racaEtnia: 'Raça/Etnia',
    rascunhoSalvoSucesso: 'Rascunho salvo com sucesso.',
    realizacao: 'Realização:',
    rede: 'Rede',
    redeAlterada: 'Rede alterada',
    redeTeleconsultoria: 'Rede de teleconsultoria',
    redeTelemedicina: 'Rede de telemedicina',
    redirecionandoEm: 'Redirecionando à tela inicial em ',
    regionalSaude: 'Gerência regional de saúde',
    rejeitar: 'Rejeitar',
    removerRede: 'Remover rede',
    requisicao: 'Requisição',
    residencia: 'Residência',
    responder: 'Responder',
    responsavel: 'Responsável',
    responsavelEnvio: 'Responsável pelo envio',
    restaurarZoom: 'Restaurar Zoom',
    retornar: 'Retornar',
    retornar: 'Retornar',
    retornarMenuModulos: 'Retornar ao menu de módulos',
    retornarTelaInicio: 'Deseja retornar a tela de Início? Dados não salvos serão perdidos.',
    retornarTelaPesquisa: 'Deseja retornar a tela de pesquisa? Dados não salvos serão perdidos.',
    rg: 'RG',
    ronda: 'Ronda',
    rgInvalido: 'RG inválido',
    rqe: 'RQE',
    sair: 'Sair',
    sairSistema: 'Sair do sistema',
    salvando: 'Salvando',
    salvandoMensagemEspera: 'Salvando...',
    salvandoPaciente: 'Salvando paciente',
    salvandoSolicitacao: 'Salvando dados da solicitação',
    salvandoTermo: 'Salvando termo de consentimento...',
    salvar: 'Salvar',
    salvarRascunho: 'Salvar rascunho',
    segundos: 'segundos',
    selecao: 'Seleção',
    selecionar: 'Selecionar',
    selecionarArquivoValido: 'Ao menos um arquivo válido deve ser selecionado',
    semelhante: 'Semelhante',
    semImagens: 'Sem imagens',
    semImagensExibicao: 'Não há imagens disponíveis para exibição.',
    semInformacao: 'Sem informação',
    semLaudo: 'Sem laudo',
    semLaudo72h: 'Atrasado',
    semSolicitante: 'Médico solicitante não informado',
    senha: 'Senha',
    sequencial: 'Sequencial',
    series: 'Séries',
    servico: 'Serviço',
    servicos: 'Serviços',
    setor: 'Setor',
    setorDuplicado: 'Esse setor já foi adicionado',
    sexo: 'Gênero',
    sigla: 'Sigla',
    sigtap: 'SIGTAP',
    sigtapAdicionado: 'SIGTAP adicionado',
    sigtapAdicionadoAnteriormente: 'Este SIGTAP já foi adicionado anteriormente.',
    sim: 'Sim',
    situacao: 'Situação',
    situacaoCadastro: 'Situação do cadastro',
    situacaoExame: 'Situação do exame',
    situacaoLaudo: 'Situação do laudo',
    situacaoUsuario: 'Situação do usuário',
    sobrepeso: 'Sobrepeso',
    solicitacao: 'Solicitação',
    solicitacaoAlteradaSucesso: 'Solicitação alterada com sucesso.',
    solicitacaoEncaminhadaSucesso: 'Solicitação encaminhada com sucesso.',
    solicitacaoExame: 'Solicitação de exame',
    solicitacaoPassagemVinculo: 'Solicitação de passagem de vínculo',
    solicitacoesExame: 'Solicitações de exames',
    solicitante: 'Solicitante',
    solicitanteAdicionado: 'Solicitante adicionado',
    solicitarAtendimento: 'Solicitar atendimento',
    somenteLetrasPermitidas: 'Somente letras são permitidas',
    somenteLetrasSemAcentoPermitidas: 'Somente letras sem acentuação são permitidas',
    somenteNumeros: 'Somente números são permitidos',
    somenteNumerosPermitidos: 'Somente números são permitidos',
    subcategoria: 'Subcategoria',
    subnutricao: 'Subnutrição',
    substituicaoAnexos: 'Substituição das imagens',
    substituirAnexos: 'CLIQUE AQUI para substituir as imagens atuais do exame',
    sucesso: 'Sucesso',
    sucessoDesvincularAutenticacaoExterna: 'Sua conta foi desvinculada a este login com sucesso.',
    sucessoEquipeAdicionada: 'Equipe adicionada com sucesso',
    sucessoInstituicaoAdicionada: 'Instituição adicionada com sucesso',
    sucessoModalidadeAdicionada: 'Modalidade adicionada com sucesso',
    sucessoPerfilAdicionado: 'Perfil adicionado com sucesso',
    sucessoSetorAdicionado: 'Setor adicionado com sucesso',
    sucessoVincularAutenticacaoExterna: 'Sua conta foi vinculada a este login com sucesso.',
    sumario: 'Sumário',
    tabagismo: 'Tabagismo',
    tamanhoCm: 'Tamanho (em CM)',
    tecnico: 'Técnico',
    telefone: 'Telefone',
    telefoneCelular: 'Telefone celular',
    telefoneComercial: 'Telefone comercial',
    telefoneFixo: 'Telefone fixo',
    telefoneInvalido: 'Telefone inválido',
    telefoneResidencial: 'Telefone residencial',
    telemedicina: 'Telemedicina',
    telessaude: 'Telessaúde',
    tempo: 'Tempo',
    tempoDoenca: 'Tempo de doença',
    tentarNovamente: 'Tentar novamente',
    termino: 'Término',
    termoCompleto: 'Termo completo',
    termoConsentimento: 'Termo de Consentimento Livre e Esclarecido',
    termoConsentimentoTeleconsulta: 'Termo de Consentimento Livre e Esclarecido para Teleconsulta',
    termoEsclarecimento: 'Termo de esclarecimento',
    termoParcial: 'Termo parcial',
    textoAguardeAtendimento: 'Aguarde seu atendimento.',
    textoAguardeSemAtendentes: 'No momento não há atendentes.',
    textoInvalidarExame: 'Para invalidar um exame devido a problemas técnicos ou de aquisição, selecione um dos motivos abaixo.',
    textoInvalidarExameObs: 'Para invalidar um exame devido a problemas técnicos ou de aquisição, informe o motivo.',
    textoTeste: 'Analisando esse exame, percebi que tal coisa e tal coisa. Recomendo tal coisa e tal coisa.',
    tipo: 'Tipo',
    tipoAnexo: 'Tipo de anexo',
    tipoAnexoObrigatorio: 'O tipo de anexo é obrigatório',
    tipoConselhoTrabalho: 'Tipo de conselho de trabalho',
    titulo: 'Título',
    tituloConfirmarEnvioExame: 'Deseja enviar as imagens?',
    tituloDecs: 'Consulta ao descritor Decs',
    tituloModalBuscarPaciente: 'Buscar paciente',
    tituloModuloApac: 'APAC',
    tituloModuloOauth2: 'Bem-vindo ao STT',
    tituloModuloOxigenoterapia: 'Oxigenoterapia Domiciliar Adulto',
    tituloModuloTfd: 'Tratamento fora do domicílio',
    todas: 'Todas',
    todasImagens: 'Todas as Imagens',
    todos: 'Todos',
    token_client_id: 'Client ID',
    token_client_secret: 'Client secret',
    token_url: 'URL token',
    total: 'Total',
    totalExames: 'Total de exames',
    transcricaoPedidoMedico: 'Transcrição do pedido médico',
    transporteRecomendado: 'Transporte recomendado',
    trocandoRede: 'Trocando rede',
    trocarRede: 'Trocar rede',
    timeLine: 'Timeline',
    turma: 'Turma',
    uf: 'UF',
    ufConselho: 'UF do conselho',
    ufDestino: 'UF de destino',
    ufOrigem: 'UF de origem',
    umTelefoneObrigatorio: 'Ao menos um número de telefone é obrigatório',
    url_base: 'URL base',
    urlInvalida: 'URL inválida',
    usuario: 'Usuário',
    usuarios: 'Usuários',
    validacaoString: {
        digitosOuNumeros: 'Este campo deve conter somente números e/ou dígitos'
    },
    valido: 'Válido',
    ver: 'Ver',
    versao_dcm4chee: 'Versão dcm4chee',
    vespertino: 'Vespertino',
    vincular: (origem) => {
        switch (origem) {
            case 'AZURE_AD':
                return 'Vincular sua conta Microsoft Azure';

            case 'GOV_BR':
                return 'Vincular sua conta gov.br';

            default:
                return 'Vincular';
        }
    },
    vinculo: 'Vínculo',
    vinculos: 'Vínculos',
    visualizacaoExames: 'Visualização de exames',
    visualizar: 'Visualizar',
    visualizarHistorico: 'Visualizar histórico',
    visualizarResumo: 'Visualizar resumo',
    voltar: 'Voltar'
};

module.exports = stringsComuns;
